module.exports = __webpack_public_path__ + "img/wy1.31b774a4.png";